import { Exportacao } from '../../../pkw-data/collect/exportacao.model'
import { OperadoraDeMaquina } from '../../../pkw-data/collect/operadora-de-maquina.model'
import { PkwDatastore } from '../../../pkw-data/pkw-datastore'
import { TiposDeMovimentoRelatorio } from '../../relatorio/opcoes-relatorio.interface'

export class ConfiguracaoExportacao {
    tipoDeTransacao: TiposDeMovimentoRelatorio
    separarPorOperadora: boolean
    separarPorTipoDeTransacao: boolean
    separarPorTipoDeVenda: boolean

    modelo: Exportacao
    private operadoras: OperadoraDeMaquina[]

    constructor(
        modeloDeExportacao: Exportacao,
        operadorasDisponiveis?: OperadoraDeMaquina[]
    ) {
        this.modelo = modeloDeExportacao
        this.operadoras = operadorasDisponiveis || []
        this.separarPorOperadora = false
        this.separarPorTipoDeTransacao = false
        this.separarPorTipoDeVenda = false
    }

    get podeApurarTaxaDeRecebimentos() {
        return (
            !this.tipoDeTransacao ||
            this.tipoDeTransacao !== TiposDeMovimentoRelatorio.Vendas
        )
    }

    get podeApurarTaxaDeVendas() {
        return (
            !this.tipoDeTransacao ||
            this.tipoDeTransacao === TiposDeMovimentoRelatorio.Vendas
        )
    }

    get podeApurarBrutoDosRecebimentos() {
        return (
            !this.tipoDeTransacao ||
            this.tipoDeTransacao !== TiposDeMovimentoRelatorio.Vendas
        )
    }

    get podeSepararPorOperadora() {
        return !this.modelo.operadora
    }

    get podeSepararPorTipoDeTransacao() {
        return !this.tipoDeTransacao
    }

    get podeSepararPorTipoDeVenda() {
        return (
            !this.tipoDeTransacao ||
            this.tipoDeTransacao === TiposDeMovimentoRelatorio.Vendas
        )
    }

    setOperadorasDisponiveis(operadoras: OperadoraDeMaquina[]) {
        this.operadoras = operadoras
    }

    gerarExportacoes(pkwDatastore: PkwDatastore): Exportacao[] {
        if (this.podeSepararPorOperadora && this.separarPorOperadora) {
            return this.operadoras
                .map(operadora => this.gerarParaOperadora(operadora, pkwDatastore))
                .reduce(
                    (todasExportacoes, exportacoesOperadora) =>
                        todasExportacoes.concat(exportacoesOperadora),
                    []
                )
        } else {
            return this.gerarParaOperadora(this.modelo.operadora, pkwDatastore)
        }
    }

    private gerarParaOperadora(
        operadora: OperadoraDeMaquina,
        pkwDatastore: PkwDatastore
    ): Exportacao[] {
        if (this.podeSepararPorTipoDeTransacao && this.separarPorTipoDeTransacao) {
            return [
                TiposDeMovimentoRelatorio.Vendas,
                TiposDeMovimentoRelatorio.Recebimentos,
                TiposDeMovimentoRelatorio.Antecipacoes
            ]
                .map(tipo => this.gerarParaTipoTransacao(operadora, tipo, pkwDatastore))
                .reduce(
                    (todasExportacoes, exportacoesDoTipo) =>
                        todasExportacoes.concat(exportacoesDoTipo),
                    []
                )
        } else {
            return this.gerarParaTipoTransacao(
                operadora,
                this.tipoDeTransacao,
                pkwDatastore
            )
        }
    }

    private gerarParaTipoTransacao(
        operadora: OperadoraDeMaquina,
        tipoDeTransacao: TiposDeMovimentoRelatorio,
        pkwDatastore: PkwDatastore
    ): Exportacao[] {
        const exportacao = this.copiarModeloDeExportacao(pkwDatastore)
        exportacao.operadora = operadora

        switch (tipoDeTransacao) {
            case TiposDeMovimentoRelatorio.Vendas:
                exportacao.exportaVendas = true
                break
            case TiposDeMovimentoRelatorio.Recebimentos:
                exportacao.exportaRecebimentos = true
                break
            case TiposDeMovimentoRelatorio.Antecipacoes:
                exportacao.exportaAntecipacoes = true
                break
            default:
                exportacao.exportaVendas = true
                exportacao.exportaRecebimentos = true
                exportacao.exportaAntecipacoes = true
        }

        return this.gerarPorTipoDeVenda(exportacao, tipoDeTransacao, pkwDatastore)
    }

    private gerarPorTipoDeVenda(
        modelo: Exportacao,
        tipoDeTransacao: TiposDeMovimentoRelatorio,
        pkwDatastore: PkwDatastore
    ) {
        if (this.podeSepararPorTipoDeVenda && this.separarPorTipoDeVenda) {
            if (tipoDeTransacao === TiposDeMovimentoRelatorio.Antecipacoes) {
                const exportacao = this.copiarModeloDeExportacao(pkwDatastore, modelo)
                exportacao.apuraDebito = false
                return [exportacao]
            }

            const debito = this.copiarModeloDeExportacao(pkwDatastore, modelo)
            debito.apuraCredito = false

            const credito = this.copiarModeloDeExportacao(pkwDatastore, modelo)
            credito.apuraDebito = false
            return [debito, credito]
        }

        return [this.copiarModeloDeExportacao(pkwDatastore, modelo)]
    }

    private copiarModeloDeExportacao(pkwDatastore: PkwDatastore, modelo = this.modelo) {
        const copia = pkwDatastore.createRecord(Exportacao, {
            aglutinaPorMes: modelo.aglutinaPorMes,
            apuraBrutoDosRecebimentos: modelo.apuraBrutoDosRecebimentos,
            apuraLiquidoDasVendas: modelo.apuraLiquidoDasVendas,
            apuraTaxaDeRecebimentos: modelo.apuraTaxaDeRecebimentos,
            apuraTaxaDeVendas: modelo.apuraTaxaDeVendas,
            dados: modelo.dados,
            inicio: modelo.inicio,
            fim: modelo.fim,
            exportaAntecipacoes: modelo.exportaAntecipacoes,
            exportaRecebimentos: modelo.exportaRecebimentos,
            exportaVendas: modelo.exportaVendas,
            empresaQueVendeComCartoes: modelo.empresaQueVendeComCartoes,
            operadora: modelo.operadora
        })

        return copia
    }
}



// WEBPACK FOOTER //
// ./src/app/extratos/exportacao-movimento/shared/configuracao-exportacao.ts